<template>
<div class="animated fadeIn">
  <!-- <resize-observer @notify="handleResize" /> -->
  <!--[start] Reach Simulation 헤더 -->
  <b-card show-footer class="bs-callout bs-callout-primary panelScrollBar" style="margin-bottom:12px;">
    <b-row style="min-width: 1200px;">
      <b-col sm="3">
        <div style="margin-top:-7px;">
          <span class="card-title wise-card-header">리치 시뮬레이션 결과</span>
        </div>
        <div class="wise-small-header">Reach Simulation Result</div>
      </b-col>
      <b-col sm="2" class="brief">
        <div class="wise-small-header">캠페인 타이틀</div>
        <div><b>{{constFormData.campaignTitle}}</b></div>
      </b-col>
      <b-col sm="2" class="brief">
        <div class="wise-small-header">총 예산 (만원)</div>
        <div><b>{{constFormData.totalBudgetStr}}</b></div>
      </b-col>
      <b-col sm="2" class="brief">
        <div class="wise-small-header">캠페인 기간</div>
        <div><b>{{constFormData.startDate}}~{{constFormData.endDate}}</b></div>
      </b-col>
      <b-col sm="1">
        <div style="padding-top:10px">
          <b-button block variant="outline-success" class="btn-pill" @click="backtoForm()">
            <span style="font-weight:900;">입력 화면</span>
          </b-button>
        </div>
      </b-col>
      <b-col sm="1">
        <div style="padding-top:10px">
          <b-button block variant="outline-primary" class="btn-pill" @click="confirmBtn()">
            <span style="font-weight:900;">확정 버튼</span>
          </b-button>
        </div>
      </b-col>
      <b-col sm="1">
        <div style="padding-top:10px">
          <b-button block variant="outline-primary" class="btn-pill" @click="excelDown()">
            <span style="font-weight:900;">엑셀 다운</span>
          </b-button>
        </div>
      </b-col>
      <b-col sm="12">
        <div style="padding-top:10px;font-size:12px;color:grey;font-weight:bold;text-align:center">
          광고효과예측솔루션은 미디어 계획에 대한 예상치를 제공할 수 있지만 특정 실적이나 결과를 보장하지는 않습니다.
          계획의 실제 실적은 광고 품질 등의 다양한 요인에 따라 달라질 수 있습니다.
        </div>
      </b-col>
      <b-collapse id="collapse1" class="mt-2" style="width:98%">
        <hr>
          <b-row style="padding-left:17px;">
            <b-col sm=12>
              <table style="border-color:transparent;width:100%">
                  <thead>
                    <tr class="wise-small-header">
                      <th style="width:30%;">시뮬레이션 타이틀</th>
                      <th style="width:25%;">광고주</th>
                      <th style="width:25%;">대행사</th>
                      <th style="width:15%;">업종</th>
                      <th style="width:15%;">Output타겟</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td><b>{{constFormData.simulationTitle}}</b></td>
                      <td><b>{{constFormData.advertiger.advt_NM}}</b></td>
                      <td><b>{{constFormData.agency.agc_NM}}</b></td>
                      <td><b>{{constFormData.industry.indt_NM}}</b></td>
                      <td><b>{{constFormData.targetCode}}</b></td>
                    </tr>
                  </tbody>
                </table>
            </b-col>
          </b-row>
          <!-- <hr> -->
          <b-row style="padding-top:20px;padding-left:17px;padding-right:17px;">
            <b-col sm=12>
              <b-table bordered hover :items="constFormData.mediaListResult" :fields="mediaListFields"></b-table>
            </b-col>
          </b-row>
      </b-collapse>
    </b-row>
    <div slot="footer" v-b-toggle.collapse1 variant="primary" style="text-align:center"><b>캠페인정보 상세보기</b></div>
  </b-card>

  <MediaLevelResult v-bind:rootFormData="formData"></MediaLevelResult>

  <ChannelLevelResult v-bind:rootFormData="formData"></ChannelLevelResult>

  <VehicleLevelResult v-bind:rootFormData="formData"></VehicleLevelResult>

  <InputLevelResult v-bind:rootFormData="formData"></InputLevelResult>

</div>
</template>

<script>
import swal from 'sweetalert2';
import reachFormData from "../../common/ReachFormData.js";
import InputLevelResult from "./result/InputLevelResult";
import VehicleLevelResult from "./result/VehicleLevelResult";
import ChannelLevelResult from "./result/ChannelLevelResult";
import MediaLevelResult from "./result/MediaLevelResult";
import leftSideUtil from "../../common/LeftSideUtil.js" // 타겟 선택 컴포넌트

import Vue from 'vue';
import VueResize from 'vue-resize';
Vue.use(VueResize);

const moment = require("moment");

export default {
  components: {
    InputLevelResult,
    VehicleLevelResult,
    ChannelLevelResult,
    MediaLevelResult,
    // TotalLevelResult
  },
  data(){
    return {
      mediaListFields: [
        {
          key: 'media',
          label: '미디어',
          thClass: 'infoTableTHClass',
          tdClass: 'infoTableTDClass'
        },
        {
          key: 'channel',
          label: '채널',
          thClass: 'infoTableTHClass',
          tdClass: 'infoTableTDClass'
        },
        {
          key: 'vehicle',
          label: '비히클',
          thClass: 'infoTableTHClass',
          tdClass: 'infoTableTDClass'
        },
        {
          key: 'targetCode',
          label: '타겟',
          thClass: 'infoTableTHClass',
          tdClass: 'infoTableTDClass'
        },
        {
          key: 'budgetStr',
          label: '예산',
          thClass: 'infoTableTHClass',
          tdClass: 'infoTableTDClass'
        },
        {
          key: 'cpmStr',
          label: 'CPM',
          thClass: 'infoTableTHClass',
          tdClass: 'infoTableTDClass'
        },
        {
          key: 'eImpStr',
          label: 'Input E.Imp',
          thClass: 'infoTableTHClass',
          tdClass: 'infoTableTDClass',
        },
        {
          key: 'outputImpressionStr',
          label: 'Output E.Imp',
          thClass: 'infoTableTHClass',
          tdClass: 'infoTableTDClass'
        },
        {
          key: 'frequency',
          label: '노출빈도',
          thClass: 'infoTableTHClass',
          tdClass: 'infoTableTDClass'
        },
        {
          key: 'mediaStartDate',
          label: '시작일',
          thClass: 'infoTableTHClass',
          tdClass: 'infoTableTDClass'
        },
        {
          key: 'mediaEndDate',
          label: '종료일',
          thClass: 'infoTableTHClass',
          tdClass: 'infoTableTDClass'
        },
      ],
      constFormData: this.$session.get('inputFormData'),
      formData: this.$session.get('inputFormData'),
      historyData:{},
    }
  },
  created: function() {

  },
  updated: function(){
  },
  mounted: function() {
    leftSideUtil.highLightMenu('reachDACustomId8642');
    this.calcEImp();
  },
  methods: {
    confirmBtn(){
      this.historyData.user_id = this.$session.get('email');
      this.historyData.std_dt = moment().format('YYYY-MM-DD HH:mm');
      this.historyData.std_dm = moment().format('YYYY-MM');
      this.historyData.confirm_name = this.constFormData.campaignTitle + '_' + this.constFormData.simulationTitle;
      this.historyData.view_type = 'DA';
      this.historyData.view_cd = 'reachSimulation';
      this.historyData.view_name = '리치시뮬레이션';
      this.historyData.formData = JSON.stringify(this.constFormData);
      this.historyData.css = "primary";

      var token = sessionStorage.getItem("myToken");
      var param = encodeURI(JSON.stringify(this.historyData));

      var data = new FormData();
      data.append('objs', param);
      var config = {
        onUploadProgress: function(progressEvent) {
          var percentCompleted = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
        }
      };

      this.$http.post('/api/insert/confirmCampaign?access_token='+token, data,config)
        .then((result) => {
          if(result.data == 'duplicate'){
            swal({
              type: 'error',
              // title: 'Oops...',
              text: "이번달에 저장된 확정안입니다."
            })
          }else if(result.data == 'ok'){
            swal({
              type: 'success',
              // title: 'Oops...',
              text: "확정안을 저장하였습니다."
            })
          }
      })
    },
    backtoForm(){
      window.location.href = "#/reach/da/reach";
    },
    calcEImp(){
    },
    excelDown(){
      var token = sessionStorage.getItem("myToken");
      var param = JSON.stringify(this.formData);

      var data = new FormData();
      data.append('objs', param);

      var config = {
        responseType: 'blob'
      };
      this.$http.post('/excel/reachResultDown',data,config)
        .then((result) => {
          const url = window.URL.createObjectURL(new Blob([result.data]));
          const link = document.createElement('a');
          link.href = url;
          var fileName = this.constFormData.campaignTitle.replace(/ /gi, '');
          fileName = fileName + "_리치시뮬레이션(DA)_" + moment().format('YYYYMMDD') ;
          link.setAttribute('download', fileName + '.xlsx'); //or any other extension
          document.body.appendChild(link);
          link.click();
        });
    }
  }

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/reach/da/ReachResult.vue